(function () {
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    if (url.includes('/cart/add')) {
      try {
        const data = await response.clone().json();
        document.dispatchEvent(new CustomEvent('cart:add', {
          bubbles: true,
          detail: { items: Array.isArray(data.items) ? data.items : [data] }
        }));
      } catch (e) {}
    }
    return response;
  };
})();